import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import UsersMonitorLeft1 from './UsersMonitorLeft1.js';
import UsersMonitorLeft2 from './UsersMonitorLeft2.js';
import UsersMonitorCenter from './UsersMonitorCenter.js';
import UsersMonitorRight from './UsersMonitorRight.js';

const UsersMonitor = ReactRouterDOM.withRouter(function () {
  const { setError } = useAppContext();
  const [branch, setBranch] = React.useState(null);
  const [user, setUser] = React.useState(null);

  return (
    <div>
      <div className="d-flex flex-wrap">
        <div className="col-lg-4 col-md-12 col-sm-12 col-12">
          <div className="p-1">
            <div className="border bg-light">
              <div className="p-2 fs-6">
                <UsersMonitorLeft1 branch={branch} setBranch={setBranch} />
              </div>
            </div>
          </div>
          {branch ? (
            <div className="p-1">
              <div className="border bg-light">
                <div className="p-2 fs-6">
                  <UsersMonitorLeft2 branch={branch} user={user} setUser={setUser} />
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <div className="col-lg-4 col-md-12 col-sm-12 col-12">
          {user ? (
            <div className="p-1">
              <div className="border bg-light">
                <div className="p-2 fs-6">
                  <UsersMonitorCenter user={user} />
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <div className="col-lg-4 col-md-12 col-sm-12 col-12">
          {user ? (
            <div className="p-1">
              <div className="border bg-light">
                <div className="p-2 fs-6">
                  <UsersMonitorRight user={user} />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
})

export default UsersMonitor;
